import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
import { Form, 
    Button, Icon, 
    Modal, 
    Table,
    Tag,
    Typography,
    Row,
    DatePicker,
    Col,
    InputNumber,
    Select,
    Alert,
    message} from "antd";
import { Map, OrderedMap } from "immutable";
import { INPUT_TYPES } from "constants";
import {
    fieldGenerator,
    getValidateStatus
} from "utilities/form";
import CompanyLosService from "./../services/company-los-services";
import moment from "moment";

const FEE_CALCULATION_TYPES = {
    0: "UNDEFINED",
    1: "FIXED",
    2: "PERCENTAGE"
};

const FEE_CALCULATION_LABELS = {
    UNDEFINED: " ",
    FIXED: "₹",
    PERCENTAGE: "%",
};

const FEE_PRODUCT_TYPE = {
    UNDEFINED: 0,
    SCF: 1,
    TERM_LOAN: 2,
    VENDOR_FINANCE: 3,
    FACTORING: 4
};

const FEE_PRODUCT_TYPE_OPTIONS = [
    { label: "SCF", value: FEE_PRODUCT_TYPE.SCF },
    { label: "TERM LOAN", value: FEE_PRODUCT_TYPE.TERM_LOAN },
    { label: "VENDOR FINANCE", value: FEE_PRODUCT_TYPE.VENDOR_FINANCE },
    { label: "CEP", value: FEE_PRODUCT_TYPE.FACTORING }
];

const getFormFields = () => new OrderedMap({
    id: {
        key: "id",
        label: "Id",
        dataIndex: "id",
        width: 0,
        type: INPUT_TYPES.NUMBER,
        className: "form-field d-none",
        disabled: true,
        trigger: "onBlur",
        valuePropName: "defaultValue",
    },
    lending_partner: {
        key: "lending_partner",
        label: "Partner Bank",
        dataIndex: "lending_partner",
        className: "form-field fb-50",
        type: INPUT_TYPES.OBJECT_SELECT,
        showSearch: true,
        getOptionsOnFocus: CompanyLosService.getLendingPartners,
        labelProp: "name",
        rules:[{
            required: true,
            message: "Please select a Partner Bank"
        }]
    },
    charge_at: {
        key: "charge_at",
        label: "Charge At",
        dataIndex: "charge_at",
        className: "form-field fb-50",
        type: INPUT_TYPES.OBJECT_SELECT,
        defaultValue: {id: 2, name: "At First Disbursal"},
        options: [
            {id: 1, name: "At Account Creation"},
            {id: 2, name: "At First Disbursal"},
            {id: 3, name: "Manually"}
        ],
        labelProp: "name",
        rules:[{
            required: true,
            message: "Please select a Charge At"
        }]
    },
    business_product_type: {
        key: "business_product_type",
        label: "Fee Product Type",
        dataIndex: "business_product_type",
        className: "form-field fb-50",
        type: INPUT_TYPES.SELECT,
        options: FEE_PRODUCT_TYPE_OPTIONS,
        rules:[{
            required: true,
            message: "Please select a Fee Product Type"
        }]
    },
});

const START_DATE = "from_date";
const END_DATE = "to_date";
const { Text } = Typography;

class CompanyFeeForm extends React.Component {
    state = {
        brandIds: new Map({}),
        removedBrands: [],
        addedBrands: false,
        feeMaster: this.props.feeMasterId,
        editableConfigurations: [],
        extendLastToLimitValues: {},
        extendingFeeMasterId: null,
        to_date: this.props.feeMasterId ? this.props.feeData && this.props.feeData.toJS().to_date? moment(this.props.feeData && this.props.feeData.toJS().to_date, "YYYY-MM-DD"):null:null,
        from_date: this.props.feeMasterId ? this.props.feeData && this.props.feeData.toJS().from_date? moment(this.props.feeData && this.props.feeData.toJS().from_date, "YYYY-MM-DD"):null:moment()
    };

    componentDidMount() {
        const selected = this.getFeeProgramRows().find(row => row.id === this.state.feeMaster);
        if (selected) {
            this.setState({
                editableConfigurations: this.toEditableConfigurations(this.getFeeConfigurations(selected))
            });
            return;
        }
        if (this.props.useLegacyFeeProgramModal) {
            return;
        }
        this.setState({
            editableConfigurations: [{
                from_limit: 1,
                to_limit: 1,
                fee_calculation_type: 1,
                value: null
            }]
        });
    }

    // componentDidMount() {
    //     if(!this.state.brandIds.size) {
    //         this.toggleFormGrid("ADD");
    //     }
    // }

    formFields = getFormFields({ allFieldsDisabled: this.props.loading });
    fieldGenerator = fieldGenerator.bind(this.props.form);
    // getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);
    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                const requiresFeeMaster = this.props.useLegacyFeeProgramModal;
                const hasRequiredFeeMaster = !requiresFeeMaster || !!this.state.feeMaster;
                // Add flow shows From/To dates; update (e.g. PF Charges) hides them — do not require dates then.
                const hasDatesWhenNeeded =
                    this.props.update || (this.state.from_date && this.state.to_date);
                if (!err && hasRequiredFeeMaster && hasDatesWhenNeeded) {
                    if (
                        !this.props.update &&
                        this.state.from_date &&
                        this.state.to_date &&
                        !this.state.from_date.isBefore(this.state.to_date, "day")
                    ) {
                        message.error("To Date must be greater than From Date.");
                        return;
                    }
                    if (this.isSelectedFeeProgramExpired()) {
                        message.error(
                            "The selected fee program has expired slab dates and cannot be submitted. Please choose a different fee program."
                        );
                        return;
                    }
                    let newValues = values;
                    newValues.charge_at = newValues.charge_at && newValues.charge_at.id;
                    newValues.lending_partner = newValues.lending_partner && newValues.lending_partner.id;
                    if (this.props.useLegacyFeeProgramModal) {
                        newValues.fee_product_type = newValues.business_product_type;
                        delete newValues.business_product_type;
                    } else {
                        delete newValues.lending_partner;
                        delete newValues.charge_at;
                        delete newValues.business_product_type;
                    }
                    newValues.fee_master = this.state.feeMaster;
                    if (!this.props.update && this.state.from_date && this.state.to_date) {
                        newValues.from_date = this.state.from_date.format("YYYY-MM-DD");
                        newValues.to_date = this.state.to_date.format("YYYY-MM-DD");
                    }
                    const normalizedConfigurations = this.getNormalizedConfigurations(this.state.editableConfigurations);
                    const skipSlabCountCheck =
                        this.props.update && this.props.useLegacyFeeProgramModal;
                    if (!skipSlabCountCheck && !normalizedConfigurations.length) {
                        message.error("Please add at least one slab configuration.");
                        return;
                    }
                    newValues.fee_seller_mapping_id = this.state.feeMaster;
                    if (!this.props.update && this.state.from_date) {
                        newValues.active_from = this.state.from_date.format("YYYY-MM-DD");
                    }
                    newValues.min_max_type = 1;
                    newValues.configurations = normalizedConfigurations.map(cfg => ({
                        fee_calculation_type: Number(cfg.fee_calculation_type),
                        value: String(cfg.value),
                        from_limit: Number(cfg.from_limit),
                        to_limit: Number(cfg.to_limit)
                    }));
                    this.props.onValuesSubmit(newValues);
                } else {
                    message.error("Please enter valid values!");
                }
            });
        }
    }

    getCharge = (type, charge) => {
        if(type === 1){
            return FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]]+charge;
        }else if(type === 2) {
            return charge+FEE_CALCULATION_LABELS[FEE_CALCULATION_TYPES[type]];
        }
        return charge;
    }

    handleDateInput = (type, _) => {
        if (
            type === END_DATE &&
            this.state[START_DATE] &&
            (this.state[START_DATE].isAfter(_) || this.state[START_DATE].isSame(_))
        ) {
            return;
        }
        if (
            type === START_DATE &&
            this.state[END_DATE] &&
            (this.state[END_DATE].isBefore(_) || this.state[END_DATE].isSame(_))
        ) {
            return;
        }
        this.setState({
            [type]: _
        });
    };

    getFeeConfigurations = (feeProgram) => {
        if (!feeProgram) {
            return [];
        }
        if (this.props.useLegacyFeeProgramModal) {
            // Legacy PF Charges modal receives flat rows from seller-configuration API.
            return feeProgram.configuration || (feeProgram.fee_master && feeProgram.fee_master.configuration) || [];
        }
        const slabs = !this.props.update
            ? feeProgram.configuration
            : feeProgram.fee_master && feeProgram.fee_master.configuration;
        return slabs || [];
    };

    isFeeProgramExpired = (feeProgram) => {
        const slabs = this.getFeeConfigurations(feeProgram) || [];
        // Disable if ANY slab is ended (active_to <= today)
        return slabs.some((s) =>
            !!s?.active_to && moment(s.active_to).isSameOrBefore(moment(), "day")
        );
    };

    isSelectedFeeProgramExpired = () => {
        if (!this.props.useLegacyFeeProgramModal || !this.state.feeMaster) {
            return false;
        }
        const row = this.getFeeProgramRows().find(r => r.id === this.state.feeMaster);
        return !!row && this.isFeeProgramExpired(row);
    };

    getFeeProgramSourceRows = () => {
        const rows = this.props.feeMaster || [];
        return rows && typeof rows.toJS === "function" ? rows.toJS() : rows;
    };

    getFeeProgramRows = () => {
        const rows = this.getFeeProgramSourceRows();
        const businessProductTypeFilter = this.props.businessProductTypeFilter;
        return rows.filter(item => {
            const hasConfig = this.props.update || this.getFeeConfigurations(item).length > 0;
            if (!hasConfig) {
                return false;
            }
            if (businessProductTypeFilter == null) {
                return true;
            }
            return Number(item.business_product_type) === Number(businessProductTypeFilter);
        });
    };

    getFeeProgramName = (row) =>
        row.name || (row.fee_master && row.fee_master.name) || "--";

    getFeeSlabRange = (row) => {
        const slabs = this.getFeeConfigurations(row);
        if (!slabs.length) {
            return "--";
        }
        const first = slabs[0];
        const last = slabs[slabs.length - 1];
        return `${first.from_limit} - ${last.to_limit}`;
    };

    formatLimit = (value) => {
        if (value == null || value === "") {
            return "--";
        }
        return Number(value).toLocaleString("en-IN");
    };

    disabledDate = (current) => {
        // Disable dates before today (previous dates)
        return current && current < moment().startOf('day');
    }

    disabledFromDate = (current) => {
        if (this.disabledDate(current)) {
            return true;
        }
        const toDate = this.state.to_date;
        if (!toDate) {
            return false;
        }
        return current && current.isSameOrAfter(toDate, "day");
    };

    disabledToDate = (current) => {
        if (this.disabledDate(current)) {
            return true;
        }
        const fromDate = this.state.from_date;
        if (!fromDate) {
            return false;
        }
        return current && current.isSameOrBefore(fromDate, "day");
    };

    getLendingPartnerOptions = () => {
        return CompanyLosService.getLendingPartners().then((res) => {
            const activeLenders = (res && res.data ? res.data : []).filter(
                lender => lender && lender.is_active
            );
            return { ...res, data: activeLenders };
        });
    };

    toEditableConfigurations = (configurations = []) => {
        const sorted = [...configurations]
            .map(cfg => ({
                from_limit: Number(cfg.from_limit || 0),
                to_limit: Number(cfg.to_limit || 0),
                fee_calculation_type: Number(cfg.fee_calculation_type || 1),
                value: cfg.value != null ? cfg.value : ""
            }))
            .sort((a, b) => a.from_limit - b.from_limit);
        return sorted.map((cfg, idx, arr) => ({
            ...cfg,
            from_limit: idx === 0 ? cfg.from_limit : Number(arr[idx - 1].to_limit || 0) + 1
        }));
    };

    setSelectedFeeMaster = (feeMasterId, row) => {
        this.setState({
            feeMaster: feeMasterId,
            editableConfigurations: this.toEditableConfigurations(this.getFeeConfigurations(row))
        });
    };

    getNormalizedConfigurations = (configurations = []) => {
        const sorted = [...configurations]
            .map(cfg => ({
                from_limit: cfg.from_limit == null ? null : Number(cfg.from_limit),
                to_limit: cfg.to_limit == null ? null : Number(cfg.to_limit),
                fee_calculation_type: Number(cfg.fee_calculation_type || 1),
                value: cfg.value
            }))
            .sort((a, b) => Number(a.from_limit || 0) - Number(b.from_limit || 0));

        return sorted.map((cfg, idx, arr) => {
            if (idx === 0) {
                return cfg;
            }
            const previousTo = Number(arr[idx - 1].to_limit);
            return {
                ...cfg,
                from_limit: Number.isFinite(previousTo) ? previousTo + 1 : cfg.from_limit
            };
        });
    };

    onSlabFieldChange = (index, key, value) => {
        const editableConfigurations = [...this.state.editableConfigurations];
        editableConfigurations[index] = {
            ...editableConfigurations[index],
            [key]: value
        };
        if (key === "to_limit") {
            for (let i = index + 1; i < editableConfigurations.length; i += 1) {
                const prevTo = Number(editableConfigurations[i - 1].to_limit);
                editableConfigurations[i].from_limit = Number.isFinite(prevTo) ? prevTo + 1 : editableConfigurations[i].from_limit;
            }
        }
        this.setState({ editableConfigurations });
    };

    addSlab = () => {
        const rows = [...this.state.editableConfigurations];
        const last = rows[rows.length - 1];
        const nextFrom = last && last.to_limit != null ? Number(last.to_limit) + 1 : 1;
        rows.push({
            from_limit: nextFrom,
            to_limit: Math.max(1, nextFrom),
            fee_calculation_type: 1,
            value: null
        });
        this.setState({ editableConfigurations: rows });
    };

    removeSlab = (index) => {
        const rows = this.state.editableConfigurations.filter((_, idx) => idx !== index);
        this.setState({ editableConfigurations: this.getNormalizedConfigurations(rows) });
    };

    onExtendLastToLimitChange = (feeMasterId, value) => {
        this.setState(prev => ({
            extendLastToLimitValues: {
                ...prev.extendLastToLimitValues,
                [feeMasterId]: value
            }
        }));
    };

    onSubmitLastToLimitUpdate = (row) => {
        const slabs = this.getFeeConfigurations(row);
        if (!slabs.length) {
            message.error("No slab found to update.");
            return;
        }
        const lastSlab = slabs[slabs.length - 1];
        const feeMasterId = row.id;
        const toLimitValue = this.state.extendLastToLimitValues[feeMasterId];
        if (toLimitValue == null) {
            message.error("Please enter To Limit.");
            return;
        }
        if (Number(toLimitValue) < Number(lastSlab.from_limit)) {
            message.error("To Limit must be greater than or equal to last slab From Limit.");
            return;
        }
        this.setState({ extendingFeeMasterId: feeMasterId });
        CompanyLosService.extendLastFeeMasterConfigurationToLimit({
            fee_master_id: feeMasterId,
            to_limit: Number(toLimitValue)
        }).then(() => {
            message.success("Last slab To Limit updated.");
            this.setState({ extendingFeeMasterId: null });
            if (this.props.refreshFeeMaster) {
                this.props.refreshFeeMaster();
            }
        }).catch((err) => {
            const errorMessage = err?.non_field_errors?.[0] || err?.message || "Failed to update last slab To Limit.";
            message.error(errorMessage);
            this.setState({ extendingFeeMasterId: null });
        });
    };


    render() {
        const feeProgramRows = this.getFeeProgramRows();
        const feeProgramColumns = this.getFeeProgramColumns();
        const useLegacyFeeProgramModal = this.props.useLegacyFeeProgramModal;
        return (
            <Modal 
                width={900}
                bodyStyle={{
                    paddingRight: "3rem",
                    paddingLeft: "3rem"
                }}
                footer={null}
                title="Add/Update Fee Program"
                visible={this.props.visible}
                onCancel={this.props.toggleModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    {!this.props.update && <>
                        <div className={"form-row align-items-center"}>
                            {this.formFields.map((field, fieldName) => {
                                if (
                                    !useLegacyFeeProgramModal &&
                                    ["lending_partner", "charge_at", "business_product_type"].includes(fieldName)
                                ) {
                                    return null;
                                }
                                if (fieldName === "channel_product") {
                                    field.onSearch = this.onSearchProducts;
                                }
                                if (fieldName === "product") {
                                    field.onSearch = CompanyLosService.getProducts;
                                }
                                if (fieldName === "lending_partner") {
                                    field.getOptionsOnFocus = this.getLendingPartnerOptions;
                                }
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getValidateStatus(fieldName)
                                )();
                            }).toList()}
                        </div>
                        <Row>
                            <Col span={12}>
                                <div className={"displayInline w-100"}>
                                    <p className={"required-field"} style={{ margin: "0px", paddingBottom: "8px" }}>From Date:</p><b />
                                    <div style={{ padding: "10 0 10 0" }}>
                                        <DatePicker
                                            disabledDate={this.disabledFromDate}
                                            style={{
                                                width: "100% !important"
                                            }}
                                            size={"default"}
                                            className={"mb-5 w-95"}
                                            onChange={this.handleDateInput.bind(
                                                null,
                                                START_DATE
                                            )}
                                            value={this.state.from_date}
                                            required={true}
                                            placeholder={"From Date"}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className={"displayInline w-100"}>
                                    <p className={"required-field"} style={{ margin: "0px", paddingBottom: "8px" }}>To Date:</p><b />
                                    <DatePicker
                                        disabledDate={this.disabledToDate}
                                        style={{
                                            width: "100% !important"
                                        }}
                                        size={"default"}
                                        className={"mb-5 w-100"}
                                        onChange={this.handleDateInput.bind(
                                            null,
                                            END_DATE
                                        )}
                                        value={this.state.to_date}
                                        required={true}
                                        placeholder={"To Date"}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </>}
                    {useLegacyFeeProgramModal ? (
                        <Table
                            bordered
                            size={"middle"}
                            className={"border-none"}
                            dataSource={feeProgramRows}
                            columns={feeProgramColumns}
                            rowKey={"id"}
                            pagination={false}
                            rowSelection={{
                                type: "radio",
                                selectedRowKeys: [this.state.feeMaster],
                                onChange: this.onFeeRowSelect,
                                getCheckboxProps: (row) => ({
                                    disabled: this.isFeeProgramExpired(row)
                                }),
                                columnWidth: 56
                            }}
                            expandedRowRender={this.renderSlabTable}
                            expandedRowKeys={this.state.feeMaster ? [this.state.feeMaster] : []}
                            onExpand={this.onFeeRowExpand}
                            expandRowByClick
                            onRow={(row) => ({
                                onClick: () => {
                                    if (this.isFeeProgramExpired(row)) {
                                        return;
                                    }
                                    this.onFeeRowClick(row);
                                }
                            })}
                            rowClassName={row =>
                                this.state.feeMaster === row.id ? "ant-table-row-selected" : ""
                            }
                            locale={{
                                emptyText: "No fee program with configuration available"
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                background: "#fafcff",
                                border: "1px solid #e8edf7",
                                borderRadius: 8,
                                padding: 12
                            }}
                        >
                            <div className={"d-flex justify-content-space-between align-items-center mb-10"}>
                                <Text strong>
                                    {this.getFeeProgramRows().find(row => row.id === this.state.feeMaster)
                                        ? this.getFeeProgramName(this.getFeeProgramRows().find(row => row.id === this.state.feeMaster))
                                        : "Fee Program Configuration"}
                                </Text>
                                <Button
                                    type={"link"}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.addSlab();
                                    }}
                                >
                                    + Add Slab
                                </Button>
                            </div>
                            {this.state.editableConfigurations.map((cfg, idx) => (
                                <Row key={`cfg-${idx}`} gutter={8} className={"mb-10"}>
                                    <Col span={6}>
                                        <Text type={"secondary"}>From Limit</Text>
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            value={cfg.from_limit}
                                            min={1}
                                            disabled={idx !== 0}
                                            onChange={val => this.onSlabFieldChange(idx, "from_limit", val)}
                                        />
                                    </Col>
                                    <Col span={6}>
                                        <Text type={"secondary"}>To Limit</Text>
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            value={cfg.to_limit}
                                            min={Math.max(1, Number(cfg.from_limit || 0))}
                                            onChange={val => this.onSlabFieldChange(idx, "to_limit", val)}
                                        />
                                    </Col>
                                    <Col span={6}>
                                        <Text type={"secondary"}>Charge Type</Text>
                                        <Select
                                            style={{ width: "100%" }}
                                            value={Number(cfg.fee_calculation_type || 1)}
                                            onChange={val => this.onSlabFieldChange(idx, "fee_calculation_type", Number(val))}
                                        >
                                            <Select.Option value={1}>₹ Fixed</Select.Option>
                                            <Select.Option value={2}>%</Select.Option>
                                        </Select>
                                    </Col>
                                    <Col span={5}>
                                        <Text type={"secondary"}>Charge Value</Text>
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            value={cfg.value}
                                            min={0}
                                            onChange={val => this.onSlabFieldChange(idx, "value", val)}
                                        />
                                    </Col>
                                    <Col span={1} className={"d-flex align-items-end"}>
                                        <Icon
                                            type={"delete"}
                                            className={"cursor-pointer"}
                                            onClick={() => this.removeSlab(idx)}
                                        />
                                    </Col>
                                </Row>
                            ))}
                        </div>
                    )}
                    {useLegacyFeeProgramModal && this.isSelectedFeeProgramExpired() ? (
                        <Alert
                            className={"mb-10"}
                            type={"error"}
                            showIcon
                            message={"This fee program cannot be submitted"}
                            description={
                                "It includes at least one slab whose end date (active to) has passed. Select a different fee program."
                            }
                        />
                    ) : null}
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button
                            type={"primary"}
                            htmlType={"submit"}
                            disabled={this.props.loading || this.isSelectedFeeProgramExpired()}
                        >
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        );
    }

    renderSlabTable = (row) => {
        if (this.props.useLegacyFeeProgramModal) {
            const slabColumns = [
                {
                    title: "From Limit",
                    dataIndex: "from_limit",
                    key: "from_limit",
                    render: value => this.formatLimit(value)
                },
                {
                    title: "To Limit",
                    dataIndex: "to_limit",
                    key: "to_limit",
                    render: value => this.formatLimit(value)
                },
                {
                    title: "Charge",
                    key: "charge",
                    render: (_, slab) =>
                        this.getCharge(slab.fee_calculation_type, slab.value),
                }
            ];
            return (
                <div
                    style={{
                        background: "#fafcff",
                        border: "1px solid #e8edf7",
                        borderRadius: 8,
                        padding: 12
                    }}
                >
                    <div className={"d-flex justify-content-space-between align-items-center mb-10"}>
                        <Text strong>{this.getFeeProgramName(row)} - Slab Configuration</Text>
                        <Tag color={"geekblue"}>{this.getFeeConfigurations(row).length} slabs</Tag>
                    </div>
                    <Table
                        bordered
                        size={"small"}
                        pagination={false}
                        rowKey={(_, idx) => `${row.id}-slab-${idx}`}
                        dataSource={this.getFeeConfigurations(row)}
                        columns={slabColumns}
                    />
                    {this.state.feeMaster === row.id && !this.props.hideLegacyLastToLimitUpdate ? (
                        <div className={"d-flex justify-content-flex-end mt-10"} style={{ gap: 8 }}>
                            <InputNumber
                                style={{ width: 180 }}
                                min={Number((this.getFeeConfigurations(row)[this.getFeeConfigurations(row).length - 1] || {}).from_limit || 0)}
                                value={
                                    this.state.extendLastToLimitValues[row.id] != null
                                        ? this.state.extendLastToLimitValues[row.id]
                                        : Number((this.getFeeConfigurations(row)[this.getFeeConfigurations(row).length - 1] || {}).to_limit || 0)
                                }
                                onChange={val => this.onExtendLastToLimitChange(row.id, val)}
                            />
                            <Button
                                type={"primary"}
                                onClick={() => this.onSubmitLastToLimitUpdate(row)}
                                loading={this.state.extendingFeeMasterId === row.id}
                            >
                                Update Last To-Limit
                            </Button>
                        </div>
                    ) : null}
                </div>
            );
        }
        const isSelectedRow = this.state.feeMaster === row.id;
        const slabData = isSelectedRow
            ? this.state.editableConfigurations
            : this.getFeeConfigurations(row);
        const slabColumns = [
            {
                title: "From Limit",
                dataIndex: "from_limit",
                key: "from_limit",
                render: value => this.formatLimit(value)
            },
            {
                title: "To Limit",
                dataIndex: "to_limit",
                key: "to_limit",
                render: value => this.formatLimit(value)
            },
            {
                title: "Charge",
                key: "charge",
                render: (_, slab) =>
                    this.getCharge(slab.fee_calculation_type, slab.value),
            }
        ];
        return (
            <div
                style={{
                    background: "#fafcff",
                    border: "1px solid #e8edf7",
                    borderRadius: 8,
                    padding: 12
                }}
            >
                <div className={"d-flex justify-content-space-between align-items-center mb-10"}>
                    <Text strong>{this.getFeeProgramName(row)} - Slab Configuration</Text>
                    <div className={"d-flex align-items-center"}>
                        {isSelectedRow ? (
                            <Button
                                type={"link"}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.addSlab();
                                }}
                            >
                                + Add Slab
                            </Button>
                        ) : null}
                        <Tag color={"geekblue"}>{slabData.length} slabs</Tag>
                    </div>
                </div>
                {isSelectedRow ? (
                    <>
                        {slabData.map((cfg, idx) => (
                            <Row key={`cfg-${idx}`} gutter={8} className={"mb-10"}>
                                <Col span={6}>
                                    <Text type={"secondary"}>From Limit</Text>
                                    <InputNumber
                                        style={{ width: "100%" }}
                                        value={cfg.from_limit}
                                        min={0}
                                        disabled={idx !== 0}
                                        onChange={val => this.onSlabFieldChange(idx, "from_limit", val)}
                                    />
                                </Col>
                                <Col span={6}>
                                    <Text type={"secondary"}>To Limit</Text>
                                    <InputNumber
                                        style={{ width: "100%" }}
                                        value={cfg.to_limit}
                                        min={0}
                                        onChange={val => this.onSlabFieldChange(idx, "to_limit", val)}
                                    />
                                </Col>
                                <Col span={6}>
                                    <Text type={"secondary"}>Charge Type</Text>
                                    <Select
                                        style={{ width: "100%" }}
                                        value={Number(cfg.fee_calculation_type || 1)}
                                        onChange={val => this.onSlabFieldChange(idx, "fee_calculation_type", Number(val))}
                                    >
                                        <Select.Option value={1}>₹ Fixed</Select.Option>
                                        <Select.Option value={2}>%</Select.Option>
                                    </Select>
                                </Col>
                                <Col span={5}>
                                    <Text type={"secondary"}>Charge Value</Text>
                                    <InputNumber
                                        style={{ width: "100%" }}
                                        value={cfg.value}
                                        min={0}
                                        onChange={val => this.onSlabFieldChange(idx, "value", val)}
                                    />
                                </Col>
                                <Col span={1} className={"d-flex align-items-end"}>
                                    <Icon
                                        type={"delete"}
                                        className={"cursor-pointer"}
                                        onClick={() => this.removeSlab(idx)}
                                    />
                                </Col>
                            </Row>
                        ))}
                    </>
                ) : (
                    <Table
                        bordered
                        size={"small"}
                        pagination={false}
                        rowKey={(_, idx) => `${row.id}-slab-${idx}`}
                        dataSource={slabData}
                        columns={slabColumns}
                    />
                )}
            </div>
        );
    };

    onFeeRowSelect = (selectedRowKeys) => {
        const selected = this.getFeeProgramRows().find(row => row.id === selectedRowKeys[0]);
        if (selected && !this.isFeeProgramExpired(selected)) {
            this.setSelectedFeeMaster(selectedRowKeys[0], selected);
        }
    };

    onFeeRowClick = (row) => {
        if (this.isFeeProgramExpired(row)) {
            return;
        }
        this.setSelectedFeeMaster(row.id, row);
    };

    onFeeRowExpand = (expanded, row) => {
        if (expanded) {
            this.setSelectedFeeMaster(row.id, row);
        } else {
            this.setState({ feeMaster: null, editableConfigurations: [] });
        }
    };

    getFeeProgramColumns = () => [
        {
            title: "Fee Program",
            dataIndex: "name",
            key: "name",
            render: (_, row) => (
                <div className={"d-flex flex-column"}>
                    <Text strong style={{ fontSize: 14 }}>{this.getFeeProgramName(row)}</Text>
                    <Text type={"secondary"} style={{ fontSize: 12 }}>
                        Click row or '+' to view slabs
                    </Text>
                </div>
            )
        },
        {
            title: "No. of Slabs",
            key: "slabs_count",
            width: 120,
            align: "center",
            render: (_, row) => (
                <Tag color={"purple"}>
                    {this.getFeeConfigurations(row).length}
                </Tag>
            )
        },
        {
            title: "Limit Range",
            key: "limit_range",
            width: 180,
            render: (_, row) => <Text>{this.getFeeSlabRange(row)}</Text>
        },
        {
            title: "Status",
            key: "selected",
            width: 120,
            align: "center",
            render: (_, row) =>
                this.state.feeMaster === row.id
                    ? <Tag color={"blue"}>Selected</Tag>
                    : <Tag>Choose</Tag>
        }
    ];
}

CompanyFeeForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.visible,
    toggleModal: PropTypes.func,
    feeMaster: PropTypes.array,
    feeMasterId: PropTypes.string,
    feeData: PropTypes.object,
    companyId: PropTypes.number,
    useLegacyFeeProgramModal: PropTypes.bool,
    refreshFeeMaster: PropTypes.func,
    businessProductTypeFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hideLegacyLastToLimitUpdate: PropTypes.bool
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
                    values
                        .toSeq()
                        .toMap()
                        .map((value) => {
                            let message = null;
                            if (value === null) {
                                message = "Field cannot be empty";
                            }
                            if (message) {
                                return Form.createFormField({
                                    value,
                                    errors: [{ message }]
                                });
                            } else {
                                return Form.createFormField({
                                    value
                                });
                            }
                        }).toJS();
    }
})(CompanyFeeForm);